import React from 'react';

import {
  Flex,
  FormLabel,
  Switch,
  Tooltip,
  Icon,
  icons,
} from '@tapresearch/ui/components';
import { Tooltips } from '../../../../shared/Tooltip/Tooltip.styled';

interface GroupAnswersSwitchProps {
  isGrouped: boolean;
  isSwitching: boolean;
  isDisabled: boolean;
  setIsGrouped: (value: boolean) => void;
  label: string;
  tooltipText?: string;
}
export const GroupAnswersSwitch = ({
  isGrouped,
  isSwitching,
  isDisabled,
  setIsGrouped,
  label,
  tooltipText,
}: GroupAnswersSwitchProps) => {
  return (
    <Flex
      data-testid="group-answers-switch-container"
      align="center"
      lineHeight="8"
      justify="flex-end"
      mt={5}
    >
      <FormLabel m={0} fontWeight="normal" fontSize="sm" lineHeight="1">
        <Flex
          align="center"
          {...(isDisabled && {
            color: 'gray.400',
          })}
        >
          {tooltipText && (
            <Tooltip
              {...Tooltips.Base}
              shouldWrapChildren
              label={tooltipText}
              placement="left"
            >
              <Icon
                wrapAs={Flex}
                icon={icons.md.InfoOutline}
                boxSize={4}
                mr={1}
              />
            </Tooltip>
          )}
          {label}
        </Flex>
      </FormLabel>
      <Flex w="45px" justify="flex-end">
        <Switch
          data-testid="group-answers-switch"
          isChecked={isGrouped}
          isDisabled={isSwitching || isDisabled}
          onChange={() => setIsGrouped(!isGrouped)}
          ml={2}
        />
      </Flex>
    </Flex>
  );
};
